type Replacer = (arg0: string) => string;

export const makeReplacer =
  (regex: RegExp) =>
  (input: string, replacer: Replacer): string =>
    input.replace(regex, (match, captured) => replacer(captured));

export const replaceHighlightableText = makeReplacer(
  /=(?!\s|&nbsp;)((?:[\w\d\s\u00C0-\u00FF</>\-()'"œ]|&quot;|&#39;)+)(?!\s|&nbsp;)=/g
);

export const tag = "mark";
export const markTagOpen = `<${tag}>`;
export const markTagClose = `</${tag}>`;
const regex = new RegExp(`${markTagOpen}(.*?)${markTagClose}`, "g");

export const replaceHighlightableString = makeReplacer(regex);

export const replaceLatex = makeReplacer(/\$\$(.+?)\$\$/g);

export default class MarkdownReplacer {
  _input: string | undefined;

  constructor(input?: string) {
    input && this.input(input);
  }

  input(input: string) {
    this._input = input;
    return this;
  }

  replaceHighlightableText(replacer: Replacer) {
    this._input = replaceHighlightableText(this._input!, replacer);
    return this;
  }

  replaceHighlightableString(replacer: Replacer) {
    this._input = replaceHighlightableString(this._input!, replacer);
    return this;
  }

  replaceLatex(replacer: Replacer) {
    this._input = replaceLatex(this._input!, replacer);
    return this;
  }

  toString() {
    return this._input;
  }
}

export const retainWhiteSpace = (input: string) => {
  const match = /^(\s+)$/g.exec(input);

  if (match) {
    return "&nbsp;";
  } else {
    return input;
  }
};
